import { useDispatch, useSelector } from "react-redux";
import EditIcon from "../../assets/images/EditIcon";
import { StaffListConstants, UserStatus } from "../../constants/constants";
import { AppDispatch, RootState } from "../../store/store";
import { UserProfile } from "./UserProfile";
import Button from "./cta/Button";
import { Cancel, editProfile, sendSmsButton } from "./styles/CommonStyles";
import { readFromLocalStorage } from "../../utils/DataEncryption";
import SendSMSIcon from "../../assets/images/SendSMSIcon";
import { getUserValidationStatus } from "./UserValidation";
import { resendConsentLinkAsync } from "../../store/thunks/userThunk";
import {
  STATUS,
  resetCameraError,
  resetFaceRecignitionStatus,
} from "../../store/slices/userDetailslice";
import { saveCameraStream } from "../../store/slices/loginSlice";
import { useEffect, useRef, useState } from "react";
import CameraPopup from "./CameraPopup";
import { updateDynamicUserDetailsAsync } from "../../store/thunks/userOnboardThunk";

export const UserProfileDetail = ({
  isEditMode,
  handleEditButton,
  handleCancelButton,
  handleSaveButton,
  activeTab,
  editButtonName,
  handleAddMoreRolesButton,
  jsonObjData,
  isAndroid = false,
  setCapturedFileImage,
  capturedFileImage,
  cameraError,
  cameraErrorstatus,
  saveEditUserDetails,
  editPayloadJson,
                isErrors,
                isErrorNotPresent,
                setEditMode,
    setIsErrors,
    setSaveWithDeletedRoles,
    setIsSaveButtonClicked,
    setShowSaveRolesButton,
    setShowPopUp,
    setIsApiSucesssful,
    userid,
    showCameraErrorMessage,
    setCapturedImage,
  capturedImage,
  cameraErrorInEditFLow,
  cameraErrorstatusInEditFLow
}: any) => {
  const dispatch = useDispatch<AppDispatch>();

  const videoRef = useRef<HTMLVideoElement | null>(null);

  const [isCameraActive, setIsCameraActive] = useState(false);

  const [confirmedImage, setConfirmedImage] = useState(false);

  const updateUserLoading = useSelector(
    (state: RootState) => state.userDetails.updateUserLoading
  );
  let isEditButtonVisible =
    (jsonObjData?.id && jsonObjData?.id.toString()) ===
      readFromLocalStorage("userId") ||
    jsonObjData?.status === UserStatus.INACTIVE
      ? false
      : true;

  const startCamera = async () => {
    setCapturedImage("");
    dispatch(resetFaceRecignitionStatus());

    dispatch(resetCameraError());

    setIsCameraActive(true);

    try {
      const stream = await navigator.mediaDevices.getUserMedia({ video: true });

      dispatch(saveCameraStream(stream));

      if (videoRef.current) {
        videoRef.current.srcObject = stream;
      }
    } catch (error: any) {
      setIsCameraActive(false);

      if (error.name === "NotFoundError") {
        // handleAlert("Camera not found.");
      } else if (error.name === "NotAllowedError") {
        // handleAlert("Permission to access camera was declined.");
      } else {
        // handleAlert("Error accessing camera.");
      }
    }
  };

  const cameraStream = useSelector(
    (state: RootState) => state.loginDetails?.cameraStream
  );

  const closeCamera = () => {
    if (cameraStream) {
      const tracks: MediaStreamTrack[] = cameraStream.getTracks(); // Get all tracks from the stream

      tracks.forEach((track) => track.stop()); // Stop each track

      if (videoRef.current) {
        videoRef.current.srcObject = null; // Clear video source to stop displaying camera feed
      }
    }
  };

  const captureImage = () => {
    const canvas = document.createElement("canvas");

    if (videoRef.current) {
      const scaleFactor = 1;

      canvas.width = videoRef.current.videoWidth * scaleFactor;

      canvas.height = videoRef.current.videoHeight * scaleFactor;

      canvas

        ?.getContext("2d")

        ?.drawImage(videoRef.current, 0, 0, canvas.width, canvas.height);

      let dataUri = canvas.toDataURL("image/jpeg");

      setCapturedImage(dataUri);

      let byteString = atob(dataUri.split(",")[1]);

      let mimeString = dataUri.split(",")[0].split(":")[1].split(";")[0];

      let ab = new ArrayBuffer(byteString.length);

      let ia = new Uint8Array(ab);

      for (let i = 0; i < byteString.length; i++) {
        ia[i] = byteString.charCodeAt(i);
      }

      let blob = new Blob([ab], { type: mimeString });

      let file = new File([blob], "image.jpg", { type: mimeString });

      setCapturedFileImage(file);

      closeCamera();
    }
  };
  return (
    <div
      className={`flex bg-white p-4  ${
        !isAndroid ? "px-5 p-5 " : "pb-4 border rounded-lg mx-4"
      } flex-col md:flex-row md:items-center md:justify-between gap-4 `}
    >
      {/* User Profile section */}
      <div className="w-full md:w-auto">
        <UserProfile
          getUserValidationStatus={getUserValidationStatus}
          jsonObjData={jsonObjData}
          isAndroid={isAndroid}
          capturedFileImage={capturedFileImage}
          cameraError={cameraError}
          cameraErrorstatus={cameraErrorstatus}
          showCameraErrorMessage={showCameraErrorMessage}
          capturedImage={capturedImage}
          startCamera={startCamera}
          cameraErrorInEditFLow={cameraErrorInEditFLow}
          cameraErrorstatusInEditFLow={cameraErrorstatusInEditFLow}
        />
      </div>
      <div
        className={`w-full   ${
          isAndroid
            ? "flex justify-between items-center gap-2 "
            : "flex justify-end items-center"
        }`}
      >
        {jsonObjData?.consentStatus === false && isEditButtonVisible && (
          <div className="pr-4  w-full md:w-auto">
            <Button
              handleClick={() =>
                dispatch(
                  resendConsentLinkAsync(jsonObjData?.userId?.toString() ?? "")
                )
              }
              buttonText={StaffListConstants.sendConsentSMSLink}
              className={`${sendSmsButton} py-3 px-4`}
              prefixIcon={<SendSMSIcon />}
            />
          </div>
        )}

        {activeTab !== 2 && activeTab !== 1 && isEditButtonVisible && (
          <div className=" w-full md:w-auto">
            {!isEditMode ? (
              <Button
                handleClick={handleEditButton}
                buttonText={editButtonName}
                className={editProfile}
                prefixIcon={<EditIcon />}
              />
            ) : (
              <div className="flex items-center justify-end gap-2">
                <Button
                  handleClick={handleCancelButton}
                  buttonText={StaffListConstants.Cancel}
                  className={Cancel}
                />
                <Button
                  handleClick={handleSaveButton}
                  buttonText={StaffListConstants.Save}
                  className={editProfile}
                />
              </div>
            )}
          </div>
        )}
      </div>
      {isCameraActive && (
        <CameraPopup
          setCapturedImage={setCapturedImage}
          setConfirmedImage={setConfirmedImage}
          videoRef={videoRef}
          capturedFileImage={capturedFileImage}
          captureImage={captureImage}
          capturedImage={capturedImage}
          startCamera={startCamera}
          isVerifyImage={true}
          setIsCameraActive={setIsCameraActive}
          buttonText={""}
          popUpMsg={""}
          popUpTitle={""}
          isOpen={true}
          onClose={() => {
            setIsCameraActive(false);
          }}
          closeCamera={closeCamera}
          isEditMode={true}
          setIsErrors={setIsErrors}
          saveEditUserDetails={saveEditUserDetails}
        />
      )}
    </div>
  );
};
